export function TooltipFormat(value){
    
   return value.toFixed(3)
}
export default TooltipFormat;